/* eslint-disable max-len */

function getOuterStyle(placement, margin) {
  // const { placement = 'top-left', margin = '16px', position } = model

  switch (placement) {
    case 'top-left':
      return {
        top: margin,
        left: margin,
        position: 'absolute'
      };
    case 'top':
      return {
        top: margin,
        left: '50%',
        position: 'absolute',
        display: 'inline-flex',
        justifyContent: 'center'
      };
    case 'top-right':
      return {
        top: margin,
        right: margin,
        position: 'absolute'
      };
    case 'right':
      return {
        top: '50%',
        right: margin,
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center'
      };
    case 'bottom-right':
      return {
        bottom: margin,
        right: margin,
        position: 'absolute'
      };
    case 'bottom':
      return {
        bottom: margin,
        left: '50%',
        position: 'absolute',
        display: 'inline-flex',
        justifyContent: 'center'
      };
    case 'bottom-left':
      return {
        bottom: margin,
        left: margin,
        position: 'absolute'
      };
    case 'left':
      return {
        top: '50%',
        left: margin,
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center'
      };
    case 'none':
      return {
        display: 'none'
      };
    default:
      return {
        bottom: margin,
        right: margin,
        position: 'absolute'
      };
  }
}
function getInnerStyle(placement, margin) {
  // const { placement = 'top-left', position } = model

  switch (placement) {
    case 'top-left':
      return {
        top: 0,
        left: 0,
        position: 'absolute'
      };
    case 'top':
      return {
        top: 0,
        position: 'absolute'
      };
    case 'top-right':
      return {
        top: 0,
        right: 0,
        position: 'absolute'
      };
    case 'right':
      return {
        right: 0,
        position: 'absolute'
      };
    case 'bottom-right':
      return {
        bottom: 0,
        right: 0,
        position: 'absolute'
      };
    case 'bottom':
      return {
        bottom: 0,
        position: 'absolute'
      };
    case 'bottom-left':
      return {
        bottom: 0,
        left: 0,
        position: 'absolute'
      };
    case 'left':
      return {
        left: 0,
        position: 'absolute'
      };
    default:
      return {
        bottom: 0,
        right: 0,
        position: 'absolute'
      };
  }
}
function getAttachment(loc) {
  switch (loc) {
    case 'top':
      return 'bottom center';
    case 'bottom':
      return 'top center';
    case 'left':
      return 'middle right';
    case 'right':
      return 'middle left';
    case 'top-right':
      return 'bottom left';
    case 'top-left':
      return 'bottom right';
    case 'bottom-right':
      return 'top left';
    case 'bottom-left':
      return 'top right';
    default:
      return 'bottom center';
  }
}

/**
 * Returns 'left', 'right', 'center' as a flex justification of
 * 'flex-start', 'flex-end', or 'center'
 */
function toFlexJustify(v) {
  switch (v) {
    case 'center':
      return 'center';
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    default:
      return 'initial';
  }
}

/**
 * Returns 'left', 'right', 'center' as a flex alignment of
 * 'flex-start', 'flex-end', or 'center'
 */
function toFlexAlign(v) {
  switch (v) {
    case 'center':
      return 'center';
    case 'top':
      return 'flex-start';
    case 'bottom':
      return 'flex-end';
    case 'baseline':
      return 'baseline';
    default:
      return 'initial';
  }
}
function buildDetailVariant(modelVariant, type = '') {
  if (!modelVariant) {
    return `detail${type}`;
  }
  const ucVariant = `${modelVariant[0].toUpperCase()}${modelVariant.substring(1)}`;
  return `detail${ucVariant}${type}|detail${type}`;
}
export default {
  getOuterStyle,
  getInnerStyle,
  getAttachment,
  toFlexJustify,
  toFlexAlign,
  buildDetailVariant
};